export const GET_DATA_INGREDIENTS_REQUEST: 'GET_DATA_INGREDIENTS_REQUEST' = 'GET_DATA_INGREDIENTS_REQUEST';
export const GET_DATA_INGREDIENTS_SUCCESS: 'GET_DATA_INGREDIENTS_SUCCESS' = 'GET_DATA_INGREDIENTS_SUCCESS';
export const GET_DATA_INGREDIENTS_ERROR: 'GET_DATA_INGREDIENTS_ERROR' = 'GET_DATA_INGREDIENTS_ERROR';

export const SET_CONSTRUCTOR_BUN: 'SET_CONSTRUCTOR_BUN' = 'SET_CONSTRUCTOR_BUN';
export const ADD_CONSTRUCTOR_INGREDIENT: 'ADD_CONSTRUCTOR_INGREDIENT' = 'ADD_CONSTRUCTOR_INGREDIENT';
export const REMOVE_CONSTRUCTOR_INGREDIENT: 'REMOVE_CONSTRUCTOR_INGREDIENT' = 'REMOVE_CONSTRUCTOR_INGREDIENT';
export const CLEAR_CONSTRUCTOR: 'CLEAR_CONSTRUCTOR' = 'CLEAR_CONSTRUCTOR';
export const MOVE_CONSTRUCTOR_INGREDIENT: 'MOVE_CONSTRUCTOR_INGREDIENT' = 'MOVE_CONSTRUCTOR_INGREDIENT';

export const GET_ORDER_REQUEST: 'GET_ORDER_REQUEST' = 'GET_ORDER_REQUEST';
export const GET_ORDER_SUCCESS: 'GET_ORDER_SUCCESS' = 'GET_ORDER_SUCCESS';
export const GET_ORDER_ERROR: 'GET_ORDER_ERROR' = 'GET_ORDER_ERROR';
export const REMOVE_ORDER_OBJECT: 'REMOVE_ORDER_OBJECT' = 'REMOVE_ORDER_OBJECT';

export const OPEN_MODAL: 'OPEN_MODAL' = 'OPEN_MODAL';
export const CLOSE_MODAL: 'CLOSE_MODAL' = 'CLOSE_MODAL';
export const OPEN_INGREDIENT_MODAL: 'OPEN_INGREDIENT_MODAL' = 'OPEN_INGREDIENT_MODAL';
export const CLOSE_INGREDIENT_MODAL: 'CLOSE_INGREDIENT_MODAL' = 'CLOSE_INGREDIENT_MODAL';
export const OPEN_ORDER_MODAL: 'OPEN_ORDER_MODAL' = 'OPEN_ORDER_MODAL';
export const CLOSE_ORDER_MODAL: 'CLOSE_ORDER_MODAL' = 'CLOSE_ORDER_MODAL';

export const SET_TAB_NAME: 'SET_TAB_NAME' = 'SET_TAB_NAME';
export const SET_TAB_OFFSETTOP: 'SET_TAB_OFFSETTOP' = 'SET_TAB_OFFSETTOP';